import { Mark } from 'tiptap'
import { toggleMark, markInputRule, markPasteRule } from 'tiptap-commands'
import Italics from "./index.vue";
export default class Italic extends Mark {
  get name() {
    return 'italic'
  }

  get schema() {
    return {
      parseDOM: [
        { tag: 'i' },
        { tag: 'em' },
        { style: 'font-style=italic' },
      ],
      toDOM: () => ['em', 0],
    }
  }

  keys({ type }) {
    return {
      'Mod-i': toggleMark(type),
    }
  }

  commands({ type }) {
    return () => toggleMark(type)
  }

  inputRules({ type }) {
    return [
    //   markInputRule(/(?:^|[^_])(_([^_]+)_)$/, type),
    //   markInputRule(/(?:^|[^*])(\*([^*]+)\*)$/, type),
    ]
  }

  pasteRules({ type }) {
    return [
    //   markPasteRule(/_([^_]+)_/g, type),
    //   markPasteRule(/\*([^*]+)\*/g, type),
    ]
  }
  menuBtnView(editorContext) {
    return {
      component: Italics,
      componentProps: {
        editorContext,
      },
      componentEvents: {
        click: (size) => {
          editorContext.commands.italic(size);
        }
      }
    };
  }

}
